import LinkedList from './LinkedList';
export class Queue {
    list;
    constructor() {
        this.list = new LinkedList();
    }
    enqueue(elem) {
        return this.list.add(elem);
    }
    add(elem) {
        return this.list.add(elem);
    }
    dequeue() {
        return this.list.removeElementAtIndex(0);
    }
    pushfront(elem) {
        return this.list.add(elem, 0);
    }
    peek() {
        return this.list.first;
    }
    size() {
        return this.list.size();
    }
    count() {
        return this.list.size();
    }
    isEmpty() {
        return this.list.isEmpty();
    }
    clear() {
        this.list.clear();
    }
    forEach(callback) {
        this.list.forEach(callback);
    }
}
export default Queue;
